
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/privacy-policy",
      function () {
        return require("private-next-pages/terms/privacy-policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/privacy-policy"])
      });
    }
  